/* ZYNOX — kart üzerinde fotoğraf gezinme.
   0. kare Dawn'ın kendi görselidir; katmandaki resimler 1..n olarak
   onun üstüne biner. Dinleyici document üzerinde, çünkü kartlar
   filtre/sayfalama sonrası yeniden basılıyor. */
(function () {
  if (window.zxSlideHazir) return;
  window.zxSlideHazir = true;

  function goster(kutu, yeni) {
    var toplam = parseInt(kutu.dataset.zxToplam, 10) || 1;
    if (toplam < 2) return;
    var i = ((yeni % toplam) + toplam) % toplam;
    kutu.dataset.zxIndex = String(i);
    kutu.querySelectorAll('.zx-slide__img').forEach(function (img) {
      img.classList.toggle('is-on', img.dataset.zxKare === String(i));
    });
    /* Gorseller seffaf PNG; ustteki alttakini ortmuyor. 0. kare disinda
       Dawn'in kendi gorselini gizle ki iki urun ust uste gorunmesin. */
    var kart = kutu.closest('.card');
    var taban = kart && kart.querySelector('.card__media');
    if (taban) taban.classList.toggle('zx-slide-gizli', i !== 0);
  }

  document.addEventListener('click', function (e) {
    var dugme = e.target.closest('[data-zx-slide-prev], [data-zx-slide-next]');
    if (!dugme) return;
    e.preventDefault();
    e.stopPropagation();
    var kutu = dugme.closest('[data-zx-slide]');
    if (!kutu) return;
    var simdi = parseInt(kutu.dataset.zxIndex, 10) || 0;
    goster(kutu, simdi + (dugme.hasAttribute('data-zx-slide-next') ? 1 : -1));
  });

  /* imleç karttan çıkınca ilk kareye dön */
  document.addEventListener(
    'mouseleave',
    function (e) {
      var kart = e.target;
      if (!kart || kart.nodeType !== 1 || !kart.matches || !kart.matches('.card-wrapper')) return;
      var kutu = kart.querySelector('[data-zx-slide]');
      if (kutu) goster(kutu, 0);
    },
    true
  );
})();

/* ZYNOX — "Bunları da beğenebilirsin" yanindaki oklar.
   Bolum ekrana girince bir kez oynar, sonra bir daha tetiklenmez. */
(function () {
  if (window.zxOkHazir) return;
  window.zxOkHazir = true;

  function baglat() {
    var hedefler = document.querySelectorAll('[data-zx-oklar]:not(.zx-oklar--in)');
    if (!hedefler.length) return;
    if (!('IntersectionObserver' in window)) {
      hedefler.forEach(function (e) {
        e.classList.add('zx-oklar--in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (girisler, gozlemci) {
        girisler.forEach(function (g) {
          if (!g.isIntersecting) return;
          g.target.classList.add('zx-oklar--in');
          gozlemci.unobserve(g.target);
        });
      },
      { threshold: 0.4 }
    );
    hedefler.forEach(function (e) {
      io.observe(e);
    });
  }

  document.addEventListener('DOMContentLoaded', baglat);
  new MutationObserver(baglat).observe(document.documentElement, { childList: true, subtree: true });
  baglat();
})();
